import script from "./TextEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextEdit.vue?vue&type=script&setup=true&lang=ts"

import "./TextEdit.vue?vue&type=style&index=0&id=184668fe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184668fe"]])

export default __exports__